const LoginPage = () => {

    return (
        <>
            <h1>Logowanie</h1>
        </>
    )
}

export default LoginPage;